import { isAuthenticated } from '../guards/auth';

export default [
  {
    path: '/soubory',
    name: 'files.history',
    meta: { moduleId: 'filesHistory' },
    component: () => import(/* webpackChunkName: "orders" */ '@/views/files/History.vue'),
    beforeEnter: isAuthenticated,
  },
  {
    path: '/soubory/detail/:id',
    name: 'files.detail',
    meta: { moduleId: 'fileDetail' },
    component: () => import(/* webpackChunkName: "orders" */ '@/views/files/Detail.vue'),
    beforeEnter: isAuthenticated,
  },
];
